import { User } from '../type/User'

const loggedInUserKey = 'loggedInUser'

export const saveLoggedInUser = (user: User): void => {
  const { password, ...userWithoutPassword } = user

  localStorage.setItem(loggedInUserKey, JSON.stringify(userWithoutPassword))
  localStorage.setItem('loggedIn', 'true')
  localStorage.setItem('userId', user.id.toString())
}

export const getLoggedInUser = (): Omit<User, 'password'> | null => {
  const storedUser = localStorage.getItem(loggedInUserKey)

  if (!storedUser) {
    return null
  }

  try {
    return JSON.parse(storedUser) as Omit<User, 'password'>
  } catch {
    localStorage.removeItem(loggedInUserKey)
    localStorage.removeItem('loggedIn')
    localStorage.removeItem('userId')
    return null
  }
}

export const clearLoggedInUser = (): void => {
  localStorage.removeItem(loggedInUserKey)
  localStorage.removeItem('loggedIn')
  localStorage.removeItem('userId')
}